import { NotFoundPage } from '@openeducation/oe-it-teacher-portal';
import * as React from 'react';

export const NotFoundScreen = () => {
  return <NotFoundPage />;
};
